import { isAuthorized, } from '@sudoplatform-private/admin-web-utils';
import React from 'react';
export const AuthGuard = ({ required, projectId, authGroups, children, noAuthFallback, }) => {
    const hasAuth = isAuthorized(required, authGroups, projectId);
    return React.createElement(React.Fragment, null, hasAuth ? children : noAuthFallback);
};
